import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start User
export const getUsersAdminService = (params) => {
  return http.get(`${base_url}/admin/users`, { params });
};
export const createUserAdminService = (data) => {
  return http.post(`${base_url}/admin/user`, data);
};
export const editUserAdminService = (data) => {
  return http.put(`${base_url}/admin/user/${data.id}`, data);
};
export const changeUserActiveAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/active`);
};
export const changeUserPasswordAdminService = (data) => {
  return http.patch(`${base_url}/admin/user/${data.id}/change-password`, data);
};
export const deleteUserAdminService = (id) => {
  return http.delete(`${base_url}/admin/user/${id}`);
};
export const verifyUserPhoneNumberAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/phone-number`);
};
export const verifyUserEmailAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/email`);
};
// End User

// Start Transaction
export const createTransactionAdminService = (data) => {
  return http.post(`${base_url}/admin/transaction`, data);
};
// End Transaction

// Start Geo
export const createGeoAdminService = (data) => {
  return http.post(`${base_url}/admin/geo`, data);
};
export const editGeoAdminService = (data) => {
  return http.put(`${base_url}/admin/geo/${data.id}`, data);
};
export const deleteGeoAdminService = (id) => {
  return http.delete(`${base_url}/admin/geo/${id}`);
};
// End Geo

// Start Log
export const getLogsAdminService = (params) => {
  return http.get(`${base_url}/admin/log`, { params });
};
export const deleteAllLogAdminService = () => {
  return http.delete(`${base_url}/admin/log`);
};
export const deleteLogAdminService = (id) => {
  return http.delete(`${base_url}/admin/log/${id}`);
};
// End Log

// Start Overview
export const getOverviewAdminService = (params) => {
  return http.get(`${base_url}/admin/overview`, { params });
};
// End Overview

// Start Web Service Profit
export const getWebServiceProfitAdminService = (params) => {
  return http.get(`${base_url}/admin/web-service-profit`, { params });
};
export const editWebServiceProfitAdminService = (data) => {
  return http.put(`${base_url}/admin/web-service-profit`, data);
};
// End Web Service Profit

// Start Snapp Trip
export const loginSnappTripAdminService = () => {
  return http.post(`${base_url}/admin/snapp-trip/login`);
};
export const getUserSnappTripAdminService = () => {
  return http.get(`${base_url}/admin/snapp-trip/user`);
};
export const checkHealthSnappTripAdminService = () => {
  return http.get(`${base_url}/admin/snapp-trip/health`);
};
export const getBooksSnappTripAdminService = (params) => {
  return http.get(`${base_url}/admin/snapp-trip/booking`, { params });
};
export const getBookSnappTripAdminService = (params) => {
  return http.get(
    `${base_url}/admin/snapp-trip/booking/${params.reservation_code}`,
    { params }
  );
};
export const getBookVoucherSnappTripAdminService = (params) => {
  return http.get(
    `${base_url}/admin/snapp-trip/booking/${params.reservation_code}/voucher`,
    { params }
  );
};
// End Snapp Trip

// Start Charter 724
export const loginCharter724AdminService = () => {
  return http.post(`${base_url}/admin/charter-724/login`);
};
export const showMyIPCharter724AdminService = () => {
  return http.get(`${base_url}/admin/charter-724/show-my-ip`);
};
export const getChargeCharter724AdminService = () => {
  return http.get(`${base_url}/admin/charter-724/charge`);
};
export const buyTicketCharter724AdminService = (data) => {
  return http.post(`${base_url}/admin/charter-724/buy-ticket`, data);
};
// End Charter 724

// Start Setting
export const getSettingAdminService = (params) => {
  return http.get(`${base_url}/admin/setting`, { params });
};
export const editSettingAdminService = (data) => {
  return http.put(`${base_url}/admin/setting`, data);
};
// End Setting

// Start Fly Order
export const changeFlyOrderStatusAdminService = (data) => {
  return http.patch(`${base_url}/admin/fly/order/${data.id}`, data);
};
// End Fly Order
